/* ─────────────────────────────────────────────────────────────────────────────
 * snap-scroll.js — per-card bg color swap (mobile) + back-print flip.
 * Contract: see /architecture/SOP_SNAP_SCROLL_HOME.md
 *
 * The page-level background color-swap runs on MOBILE ONLY (D-015): below the
 * 1024px breakpoint the layout is the one-product-per-viewport snap-scroll, so
 * exactly one product is on screen and a global swap is meaningful. On desktop
 * the layout is a scattered floating canvas with all products visible, so the
 * observer is disabled there.
 *
 * No dependencies.
 * ───────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  const root = document.documentElement;
  const cards = document.querySelectorAll('[data-snap-card]');
  if (!cards.length) return;

  const mobileQuery = window.matchMedia('(max-width: 1023px)');

  /**
   * Set the global signature/contrast colors from a card's dataset.
   * @param {HTMLElement} card
   */
  function setColors(card) {
    const sig = card.dataset.signature;
    const con = card.dataset.contrast;
    if (sig) root.style.setProperty('--signature', sig);
    if (con) root.style.setProperty('--contrast', con);
  }

  // Initialize page colors from the first card (mobile bg base / desktop neutral).
  setColors(cards[0]);

  let io = null;

  function startObserver() {
    if (io) return;
    io = new IntersectionObserver(
      function (entries) {
        for (let i = 0; i < entries.length; i++) {
          const entry = entries[i];
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            setColors(entry.target);
          }
        }
      },
      { threshold: [0.5] }
    );
    cards.forEach(function (card) { io.observe(card); });
  }

  function stopObserver() {
    if (!io) return;
    io.disconnect();
    io = null;
    setColors(cards[0]); // reset to a stable base color on desktop
  }

  function applyMode() {
    if (mobileQuery.matches) startObserver();
    else stopObserver();
  }

  applyMode();

  // Re-evaluate if the viewport crosses the 1024px breakpoint.
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', applyMode);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(applyMode); // older Safari fallback
  }

  // ── Back-print flip toggle (works on all viewports) ─────────────────────
  function setCardSide(card, showBack) {
    const front = card.querySelector('.snap-card__image--front');
    const back = card.querySelector('.snap-card__image--back');
    if (!front || !back) return;
    front.hidden = showBack;
    back.hidden = !showBack;

    const btn = card.querySelector('[data-snap-flip]');
    if (btn) btn.setAttribute('aria-pressed', String(showBack));
  }

  document.querySelectorAll('[data-snap-card]').forEach(function (card) {
    const btn = card.querySelector('[data-snap-flip]');
    if (btn) {
      btn.addEventListener('click', function () {
        const back = card.querySelector('.snap-card__image--back');
        if (!back) return;
        setCardSide(card, back.hidden);
      });
    }

    card.addEventListener('pointerenter', function () {
      if (mobileQuery.matches) return;
      setCardSide(card, true);
    });

    card.addEventListener('pointerleave', function () {
      if (mobileQuery.matches) return;
      setCardSide(card, false);
    });
  });
})();
